import {inject, Injectable, InjectionToken} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {PathKind} from "@angular/forms/signals";

export let commBaseURL = new InjectionToken<string>('commBaseURL');

interface DriverPageUrlResponse {
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class CommService {

  protected httpClient: HttpClient;
  protected _baseUrl: string;

  constructor() {
    //        this.authHttp = inject( AuthHttp );
    this.httpClient = inject(HttpClient);
    this._baseUrl = inject(commBaseURL);
  }

  public async getDriverUrl(badgeId: string): Promise<string> {

    const response = await firstValueFrom(
      this.httpClient.get<DriverPageUrlResponse>(this._baseUrl + '/driver/url/' + badgeId, {})
    );
    return response.url;
  }
}
